<template>
  <div id="pain-point-picker" style="width:265px; height:636px;">
    <button @click="clearPoints" style="position: absolute; top: 0; left: 0;">
      Limpiar
    </button>
    <img
      ref="image"
      width="265"
      height="636"
      @click="imageClick"
      :src="`/images/${view}.png`"
    />
    <div
      v-for="(point, index) in points"
      :key="index"
      class="point"
      :style="{ top: point.y, left: point.x }"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["view", "value"],
  data() {
    return {
      points: this.value,
    };
  },
  watch: {
    value: function(v) {
      this.points = v;
    },
  },
  methods: {
    clearPoints() {
      this.points = [];
      this.$emit("input", this.points);
    },
    imageClick(e) {
      const height = this.$refs.image.clientHeight;
      const width = this.$refs.image.clientWidth;
      const x = e.offsetX;
      const y = e.offsetY;

      const y_ptg = ((y * 100) / height).toFixed(2) + "%";
      const x_ptg = ((x * 100) / width).toFixed(2) + "%";
      this.points.push({
        x: x_ptg,
        y: y_ptg,
      });
      this.$emit("input", this.points);
    },
  },
};
</script>

<style scoped>
.point {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 5px;
}

#pain-point-picker {
  position: relative;
}
</style>
